<template>
    <div class="xxdata">
        <vx-card title="基本信息">

            <div class="p-6" style="max-width: 300px;">

                <gc-cmp-vs-input label="角色名称" id="el_name"  v-model="role_name"  maxlength="50"
                                 class="mt-5 w-full" placeholder="请输入角色名称"  @input="changeValue('role_name')"/>

                <gc-cmp-form-select v-model="user_type" :options="account_opts" ref="form_select"
                                    select-placeholder="请选择角色类型" label="角色类型"


                />

            </div>

        </vx-card>

        <vx-card title="权限设置" class="mt-10">
            <div class="p-6" style="">
                <role-tree-menu-form ref="tree_form" :tree="menus" />
            </div>

        </vx-card>


        <vx-card title="" class="mt-10">
            <div class="p-6" style="">
<!--                <vs-button type="border" color="primary" @click="loadMenus">加载</vs-button>-->

                <gc-cmp-vs-submit-button class="mr-6" :condition="validate" :parameters="getParam" :uri="getSaveUrl"
                                         v-on:respond-success="savedOK" v-on:respond-fail="saveFail">保存</gc-cmp-vs-submit-button>

                <vs-button type="border" color="danger" @click="cancelAffirm">取消</vs-button>

            </div>

        </vx-card>

    </div>
</template>

<script>

    import GcCmpVsSubmitButton from "@/group-cloud/components/vsButton.submit";
    import GcCmpVsInput from "@/group-cloud/components/vsInput";
    import {GC_Validator} from "@/group-cloud/components/validator/Validator";
    import GcCmpFormSelect from "@/group-cloud/components/form/select/GC-Cmp-Select";
    import {Mod_Account, Mod_Account_Types, Mod_Account_Type_Opts} from '@/modules/server-api/Accounts';
    import {Mod_Roles} from '@/modules/server-api/Roles';
    import {Navigator} from "@/router/Navigator";
    import RoleTreeMenuForm from "./menu_tree_form";

export default {
    components: {
        RoleTreeMenuForm,
        GcCmpFormSelect,
        GcCmpVsInput,
        GcCmpVsSubmitButton,
    },
    data () {
        return {
            user_id: 0,
            role_id: 0,
            role_name: '',
            user_type: Mod_Account_Types.HEAD_QUARTER,
            account_opts: Mod_Account_Type_Opts,
            roles: [],
            menus: [],
            loaded: false
        }
    },
    computed: {
        getSaveUrl() {
            return  this.role_id > 0 ? 'auth_center/yooz/role/update' : 'auth_center/yooz/role/add';
        },
        getParam() {
            let param = {
                group_id: this.user_type,
                rolename: this.role_name,
                tenant_id: '0',
            };
            if (this.role_id > 0) {
                param.role_id = this.role_id;
            }
            return param;
        },
            //校验字符：最多输入25个中文，或者50个英文
        changeValue(attr) {
            console.log(111)
            console.log('attr',attr)
            let value = this.role_name; //校验的字段
            // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
            let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/;
            let maxLimitStr = 25; //25个汉字
            let pass = true;
            let substringStr = "";
            let length = 0;
            let strArr = value.split("");
            strArr.map((str) => {
                if (pass) {
                if (cnReg.test(str)) {
                    //中文
                    length++;
                } else {
                    //英文
                    length += 0.5;
                }
                //大于最大限制的时候
                if (length > maxLimitStr) {
                    pass = false;
                    this.$notifyError(
                    "文字长度已超出最大值，最大值为" + maxLimitStr * 2 + "个字符",
                    );
                    //将校验的字符截取返回
                    this.role_name = substringStr;
                } else {
                    substringStr += str;
                }
                }
            });
            return pass;
            // let mat = value.match(cnReg)
            // if (mat) {
            //     length = (mat.length + (value.length - mat.length) * 0.5)
            //     return length
            // } else {
            //     return value.length * 0.5
            // }
        },
    },
    watch: {
        user_type(update) {
            this.getAllMenus();
        }
    },
    methods: {
        validate() {
            return true;
        },
        async getAllMenus() {
            let resp = await Mod_Roles.getMenus(this.user_type);

            let roleId = this.role_id;
            let menuIds = await Mod_Roles.getRoleMenus(roleId);
            if (resp.length) {

                Mod_Roles.markCheckedTree(resp, menuIds);

                this.menus = resp;
            }
            // console.log(['menus',  this.menus]);

            return resp;
        },

        async getRoleMenus(roleId) {
            let menuIds = await Mod_Roles.getRoleMenus(roleId);

        },
        loadMenus() {
            this.getAllMenus();
        },
        async savedOK(payload) {
            // console.log(['save-ok-payload', payload]);
            if (payload && payload.succ) {

                if (payload.result && payload.result.role_id > 0) {
                    this.role_id = parseInt(payload.result.role_id);
                }

                let menus = this.$refs.tree_form.queryChecked();
                let bindOk = await Mod_Roles.bindRoleMenus(this.role_id, menus);

                // console.log(['save-role', menus, bindOk]);

                if (bindOk) {

                    this.$notifySuccess('保存成功');

                    let path = `/modules/roles/list`;
                    Navigator.redirect(path);
                    return;
                }
            }
            // this.loadUser();
            this.$notifyError('保存失败');
        },
        saveFail(err) {
            this.$notifyError(err);

        },
        // 确认取消 
        cancelAffirm(){
            this.$vs.dialog({
            type: "confirm",
            title: `请确认`,
            text: `是否确认取消`,
            acceptText: "确认",
            cancelText: "取消",
            accept: () => {
            this.cancel();
            },
           });
        },
        cancel() {
            let path = `/modules/roles/list`;
            Navigator.redirect(path);
        },

        async loadRoleInfo(rid) {
            let resp = await Mod_Roles.loadRoleInfo(rid);
            // console.log(['loadRoleInfo', resp]);
            if (resp.id > 0) {
                this.role_name     = resp.rolename;
                this.user_type     = resp.group_id;
            } else {
                this.role_name     = '';
                this.user_type     = Mod_Account_Types.HEAD_QUARTER;
            }
            return resp;
        },
        async init(route) {
            let _route = route || this.$route;
            // console.log(['init-route', _route]);
            if (_route.params.role_id > 0) {
                this.role_id = parseInt(_route.params.role_id);
            } else {
                this.role_id = 0;
            }
            await this.loadRoleInfo(this.role_id);
            await this.getAllMenus();
        },
    },
    beforeRouteUpdate (to, from, next) {
        // console.log('route-change', to);
        this.init(to);

    },
    created() {
        this.init();
    }
}
</script>
